import { trackClientEvent } from '@faire/web-api--source/trackClientEvent';
import { ITraceEventMarker } from '@faire/web/common/pete/TraceEventTracker';

export const eventKey = 'user_invitation-sign_up_as_new_user-view';

/**
 * User lands on signup page, either directly via invitation or after deactivating their current account.
 */
export function trackUserInvitationSignUpAsNewUserView(
  Invitation_Token_string: string
): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: false,
    parameters: { Invitation_Token_string },
  });
}
